import MessageBubble from './MessageBubble'
import { formatDistanceToNow } from 'date-fns'

const MessageList = ({ messages, currentUser }) => {
  console.log('📝 MessageList received:', { 
    messagesCount: messages?.length || 0, 
    currentUser: currentUser?.username,
    messages: messages?.map(m => ({ id: m._id, content: m.content, sender: m.sender?.username }))
  })
  
  // Group messages by date
  const groupMessagesByDate = (messages) => {
    const groups = {}
    
    messages.forEach(message => {
      const date = new Date(message.createdAt).toDateString()
      if (!groups[date]) {
        groups[date] = []
      }
      groups[date].push(message)
    })
    
    return groups
  }

  const messageGroups = groupMessagesByDate(messages)

  if (messages.length === 0) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <div className="text-center">
          <div className="mx-auto h-12 w-12 flex items-center justify-center rounded-full bg-gray-100 dark:bg-gray-800 mb-4">
            <svg className="h-6 w-6 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
            </svg>
          </div>
          <p className="text-gray-500 dark:text-gray-400">No messages yet</p>
          <p className="text-sm text-gray-400 dark:text-gray-500 mt-1">
            Send a message to start the conversation
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      {Object.entries(messageGroups).map(([date, dateMessages]) => (
        <div key={date}>
          {/* Date separator */}
          <div className="flex items-center justify-center mb-4">
            <div className="bg-gray-100 dark:bg-gray-800 px-3 py-1 rounded-full">
              <span className="text-xs text-gray-500 dark:text-gray-400">
                {formatDistanceToNow(new Date(date), { addSuffix: true })}
              </span>
            </div>
          </div>

          {/* Messages for this date */}
          <div className="space-y-2">
            {dateMessages.map((message, index) => {
              const prevMessage = index > 0 ? dateMessages[index - 1] : null
              const nextMessage = index < dateMessages.length - 1 ? dateMessages[index + 1] : null
              
              // Group consecutive messages from the same sender
              const isFirstInGroup = !prevMessage || prevMessage.sender._id !== message.sender._id
              const isLastInGroup = !nextMessage || nextMessage.sender._id !== message.sender._id
              
              return (
                <MessageBubble
                  key={message._id}
                  message={message}
                  currentUser={currentUser}
                  isFirstInGroup={isFirstInGroup}
                  isLastInGroup={isLastInGroup}
                />
              )
            })}
          </div>
        </div>
      ))}
    </div>
  )
}

export default MessageList